import React from 'react';
import { number, string, bool, func } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { Checkbox, Tooltip, Icon } from '@fiverr-private/fit';
import { s_question_circle } from '@fiverr-private/icons';
import { formatDaysKey } from '../../../../utils/packagesUtils';

import './style.scss';

const PackageExtraCheckbox = ({ checked, label, tooltipContent, onChange, currentDuration }) => (
    <Checkbox className="package-extra-checkbox"
        checked={checked}
        onChange={onChange}>
        <div>
            <div>
                <span className="checkbox-label">{label}</span>
                {tooltipContent &&
                <Tooltip className="checkbox-tooltip"
                    boxContentClassName="tooltip-box-content"
                    content={tooltipContent}
                    appendToBody={false}>
                    <Icon size={12}>{s_question_circle}</Icon>
                </Tooltip>
                }
            </div>
            {currentDuration > 0 &&
            <div className="current-duration">
                (+{currentDuration} <I18n k={formatDaysKey(currentDuration)}/>)
            </div>
            }
        </div>
    </Checkbox>
);

PackageExtraCheckbox.propTypes = {
    checked: bool,
    label: string,
    tooltipContent: string,
    onChange: func,
    currentDuration: number
};

export { PackageExtraCheckbox };
